import React from 'react';
/* CSS */
import './style.css';

export const Button = ({ isSimulator = false, isRecap = false, color = "red", hollow = false, type = "button", rounded = false, text, clickEvent = function() {}, className = "", disabled = false, onMouseOver = function(){}, onMouseOut = function() {}, innerRef = null}) => {
  return (
    <div className={`${ isSimulator ? "calculate-btn-scp" : ""} ${ isRecap ? "loan-btn-rpp" : ""}`}>
      <button 
        type={type}
        ref={innerRef} 
        className={`${className} comman-btn-rpp ${ color === "white" ? "" : "red-btn-rpp" } ${ hollow ? "comman-border-btn-rpp" : "" } ${ rounded ? "comman-btn-rpp--rounded" : "" } ${ disabled ? "disabled" : "" }`} 
        onClick={clickEvent}
        onMouseOver={onMouseOver}
        onMouseOut={onMouseOut}
      >
        { text }
      </button>
    </div>
  );
}
